module.exports = __webpack_public_path__ + "img/relacionamento-canais-electrolux-v1.55b4cf71.png";